var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"id"},[_c('div',{staticClass:"navBar",on:{"click":function($event){return _vm.$router.back()}}},[_c('van-icon',{attrs:{"name":"arrow-left"}}),_vm._v(" "+_vm._s(_vm.content.title)+" ")],1),_c('div',{staticStyle:{"padding":"10px","padding-top":"0"},domProps:{"innerHTML":_vm._s(_vm.content.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }